import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { rejects } from 'assert';
import { AgendaService } from '../../../../services/agenda.service';
import { ArquivoService } from '../../../../services/arquivo.service';
import { LoginService } from '../../../../services/login.service';
import { ParametrosService } from '../../../../services/parametros.service';
import { UploadAtendimentoService } from '../../../../services/upload-atendimento.service';
import { PaginaEsperaComponent } from '../pagina-espera/pagina-espera.component';
import { PaginaPerguntaComponent } from '../pagina-pergunta/pagina-pergunta.component';

export interface Arquivo {
  NomeArquivo: string,
  PathArquivo: string,
  Base64String: string,
  Descricao: string
}

@Component({
  selector: 'ngx-solucao-tarefa',
  templateUrl: './solucao-tarefa.component.html',
  styleUrls: ['./solucao-tarefa.component.scss']
})
export class SolucaoTarefaComponent implements OnInit {

  public usuarioLogado: any;
  public arquivo: Arquivo = null;
  public idTipoServico: number = 0;
  public caixaTexto: FormGroup;
  public contentType: string = "";
  private DadosRecebidos: any;
  public ListaArquivos: any[] = [];
  private ListaArquivosUpload: any[] = [];
  public colunaNomeArquivo: string[] = ['nome'];
  public caminhoRelativo: string = "";
  public servicosAnexo: any[] = [];
  public necessarioAnexo: boolean = false;


  constructor(private dialogRef: MatDialogRef<PaginaPerguntaComponent>,
    public formBuilder: FormBuilder,
    public uploadService: UploadAtendimentoService,
    public arquivoService: ArquivoService,
    public parametrosService: ParametrosService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data,
    private loginService: LoginService) {

    this.usuarioLogado = this.loginService.getUsuarioDadosCompletos();


    this.necessarioAnexo = data.necessarioAnexo
  }

  async ngOnInit() {

    this.caixaTexto = this.formBuilder.group({
      texto: [[''], [Validators.required, Validators.minLength(2)]],
    })

    await this.parametrosService.getParametro("CaminhoPastaContratosSalvos").toPromise()
      .then(response => {
        if (response) {
          this.caminhoRelativo = response[0].Valor
        }
      })



  }

  AbrirCaixaArquivos() {
    document.getElementById('CaixaArquivos').click();
  }

  async ArquivosSelecionados(arquivos: any) {
    await this.CriarObjetoUpload(arquivos);
  }


  async CriarObjetoUpload(listaAnexo: FileList) {

    if (listaAnexo.length > 0) {

      if (listaAnexo.length == 1) {

        const reader: FileReader = new FileReader();

        this.contentType = listaAnexo[0].name.substring(listaAnexo[0].name.indexOf(".") + 1, listaAnexo[0].name.length)

        reader.onload = async (x) => {
          this.arquivo = {
            NomeArquivo: `Contrato_`,
            Descricao: listaAnexo[0].name,
            PathArquivo: this.caminhoRelativo,
            Base64String: btoa(reader.result.toString())
          }
          //this.EnviarArquivo();
        }
        reader.readAsBinaryString(listaAnexo[0])
      }
    }


  }

  public ExcluirArquivo() {
    this.arquivo = null
  }

  public Resposta(resposta: boolean) {

    this.dialogRef.close({ resposta: resposta, texto: this.caixaTexto.value.texto, arquivo: this.arquivo })
  }

  public VerificaAnexo() {
    if (this.necessarioAnexo) {
      if (this.arquivo != null) {
        return false;
      } else {
        return true;
      }
    }

    return false;
  }

}
